/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FormState, FormStateBuilder, getDialogInitData, MaskedTypes } from '@gh/common-shared';
import { DialogInput, NotificationService, WaitingService } from '@gh/core-ui';

import {
  LocationBusinessService,
  LocationDetailsDialogConfig,
} from '../../resources/location-business.service';
import { Location } from '../../resources/location.model';

@Component({
  standalone: false,
  selector: 'gh-location-details-dialog',
  templateUrl: 'location-details-dialog.component.html',
  styleUrls: ['location-details-dialog.component.scss'],
})
export class LocationDetailsDialogComponent implements DialogInput<LocationDetailsDialogConfig>, OnInit {
  input: LocationDetailsDialogConfig;

  form: FormState<Location>;

  constructor(private notificationService: NotificationService,
              private locationBusiness: LocationBusinessService,
              public dialogRef: MatDialogRef<LocationDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              private waitingService: WaitingService,
              private formStateBuilder: FormStateBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain<Location>({
      value: getDialogInitData(this.dialogData),
      optimisticLock: true,
      children: {
        id: void 0,
        city: { required: true },
        state: void 0,
        postcode: {
          type: MaskedTypes.Zip,
        },
      },
    });
  }

  onSubmit(): void {
    this.locationBusiness.update(this.form.value).pipe(
      this.waitingService.operator<Location>())
      .subscribe(
        (location) => {
          this.dialogRef.close(location);
          this.notificationService.success('msg_saved_successfully');
        },
        (errors) => this.notificationService.processAll(errors),
      );
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
